define('app-route-provider',[
  '_',  'angular-storage', 'oc-lazy-load', 'jquery-deparam', 'config-service'
], function() {

  var app = angular.module('app.route.provider', ['ui.router', 'ngStorage', 'oc.lazyLoad', 'config.service']);


  app.provider('appRoute', ['configProvider',

    function AppRouteProvider(configProvider) {

      var routes = configProvider.routes;

      this.routes = routes;

      var getter = this.get = function(key) {
        var route = _.get(routes, key);
        return route;
      };

      /*
        Aqui temos uma tentativa de modularizar o carregamento de estados, infelizmente não funcionou :(
        O problema é que o ui-router não carrega os módulos lazy loading corretamente pois a renderização
        da página é feita pelo Swig no back-end e não pelo AngularJS no front-end, o que faz com que o
        carregamento dos módulos seja feito de forma síncrona e não sob demanda.
        Caso for implementar algo do tipo, boa sorte...
        Origado,

        @Barella
      */
      // this.state = function(state, options) {
      //   var defaultStates = ['default', 'dashboard'];

      //   var defaults = {
      //     module: _.kebabCase(state),
      //     resolve: {},
      //     dependencies: []
      //   };

      //   var config = _.merge(defaults, options);

      //   if (!config.packagee) {
      //     config.packagee = config.module;
      //   }

      //   // Se for um estado padrão, marca como abstrato e não define URL
      //   if (defaultStates.includes(state)) {
      //     config.abstract = true;
      //     config.url = '';
      //   }
      //   // Se não for um estado padrão e não tiver parent definido e não tiver skipDefault
      //   else if (!config.parent && (!config.data || !config.data.skipDefault)) {
      //     // Define o parent como default
      //     config.parent = 'default';
      //   }

      //   // Verifica se templateUrl existe antes de tentar acessar
      //   if (config.templateUrl) {
      //     if (config.templateUrl.indexOf('tpl.') > -1) {
      //       config.templateUrl = '/site/public/theme/' + configProvider.theme + '/view/' + config.templateUrl.replace('tpl.', '');
      //     } else {
      //       config.templateUrl = '/site/module/' + config.packagee + '/public/theme/' + configProvider.theme + '/view/' + config.templateUrl;
      //     }
      //   }

      //   if (config.url && config.url !== '') {
      //     config.url = this.get(config.url);
      //   }

      //   if (config.params) {
      //     var queryParams = new URI();
      //     queryParams.query(config.params);
      //     config.url = config.url + '?' + queryParams.query();
      //   }
        
      //   // Configura os caminhos para o controlador e resource - sempre carregados sob demanda
      //   if (config.controller) {
      //     console.log('[Route Provider] Configurando carregamento de dependências para', config.module);
          
      //     // Configura os caminhos dos arquivos a serem carregados
      //     var controllerPath = '/site/module/' + config.packagee + '/public/app/controller/' + config.module + '-controller';
      //     var resourcePath = '/site/module/' + config.packagee + '/public/app/resource/' + config.module + '-resource';
          
      //     // Adiciona o controller e resource às dependências
      //     if (!config.dependencies) {
      //       config.dependencies = [];
      //     }
          
      //     // Adiciona dependências usando o formato requirejs
      //     config.dependencies.push(controllerPath, resourcePath);
          
      //     // Configura o resolve para carregar todas as dependências quando o state for ativado
      //     config.resolve = _.merge(config.resolve, {
      //       load: ['$ocLazyLoad', '$q', '$timeout', function($ocLazyLoad, $q, $timeout) {
      //         console.log('[Route Provider] Carregando dependências para', state);
      //         var deferred = $q.defer();
              
      //         try {
      //           $ocLazyLoad.load(config.dependencies).then(
      //             function success(data) {
      //               console.log('[Route Provider] Dependências carregadas com sucesso para', state);
      //               // Dá um pequeno atraso para garantir que o AngularJS compile tudo
      //               $timeout(function() {
      //                 deferred.resolve(data);
      //               }, 50);
      //             },
      //             function error(err) {
      //               console.error('[Route Provider] Erro ao carregar dependências para', state, err);
      //               deferred.reject(err);
      //             }
      //           );
      //         } catch (e) {
      //           console.error('[Route Provider] Exceção ao carregar dependências para', state, e);
      //           deferred.reject(e);
      //         }
              
      //         return deferred.promise;
      //       }]
      //     });
      //   }

      //   // Debug para acompanhar a configuração do estado
      //   console.log('[Route Provider] Configurando estado', state, 'com template', config.templateUrl);

      //   // Registra o estado no $stateProvider
      //   $stateProvider.state(state, config);

      //   return this;
      // };

      this.getRoutes = function() {
        return routes;
      };

      // Factory function
      this.$get = ['$location', function appRouteFactory($location) {

        this.linkTo = function() {

          try {

            var args = Array.prototype.slice.call(arguments);
            var key = args[0];

            if (args.length > 2) {
              data = args.shift();
            } else {
              data = args[1];
            }

            var route = _.get(this.routes, key);
            var re;

            if (_.isString(data) || _.isNumber(data)) {
              re = new RegExp('\:.+\\??\/?');
              route = route.replace(re, data + '/');
            } else if (_.isPlainObject(data) && !_.isEmpty(data)) {
              _.mapKeys(data, function(v, k) {
                re = new RegExp('\:' + k + '\\??');
                route = route.replace(re, v);
              });
            } else if (_.isArray(data)) {
              re = new RegExp('\:.+\\??\/?');
              data.map(function(v) {
                route = route.replace(re, v);
              });
            } else if (!data) {
              re = new RegExp('\:.+\\??\/');
              route = route.replace(re, '');
            }

            return route;

          } catch (error) {

            console.log('Couldn\'t create link to ' + key);
            return '#';

          }

        };

        this.compactSearchParams = function(data, options) {

          var defaults = {
            serialize: false
          };

          var settings = _.merge({}, defaults, options);

          var params = {};

          if (!data) {
            data = $location.search();
          }

          if (data.currentPage && parseInt(data.currentPage) > 1) {
            params.currentPage = data.currentPage;
          }

          if (data.itemsPerPage && data.itemsPerPage != 3) {
            params.itemsPerPage = data.itemsPerPage;
          }

          if (_.isString(data.searchParams) && !_.isEmpty(data.searchParams) && !settings.serialize) {
            params.searchParams = $.deparam(data.searchParams);
            angular.extend(this, params); // this === $scope
          } else if (_.isPlainObject(data.searchParams) && !_.isEmpty(_.removeFalsies(data.searchParams)) && settings.serialize) {
            params.searchParams = $.param(data.searchParams);
          }

          return params;

        };

        this.setLocationSearch = function(data) {

          var params = this.compactSearchParams(data, {
            serialize: true
          });

          $location.search(params);

        };

        this.redirect = function(data) {

          var path;

          if (data && _.isPlainObject(data) && data.redirect) {
            path = data.redirect;
          } else {
            path = data;
          }

          if (path && _.isString(path)) {
            $location.path(path)
          }

        };

        return this;

      }];

    }
  ]);

  return app;

});

